import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Autres informations", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, null, -1)
const _hoisted_9 = { class: "table" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Nom:", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Slug:", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "bl" }, "Collection:"),
  /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "col-6" })
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_router_link, {
              to: "/liste-collections",
              class: "btn btn-primary transition border-0 lh-1 fw-medium"
            }, {
              default: _withCtx(() => [
                _hoisted_7,
                _hoisted_8,
                _createTextVNode("Retour")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("table", _hoisted_9, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _hoisted_10,
                _createElementVNode("td", null, _toDisplayString(_ctx.collection?.name), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_11,
                _createElementVNode("td", null, _toDisplayString(_ctx.collection?.slug), 1)
              ]),
              _hoisted_12
            ])
          ])
        ])
      ])
    ])
  ]))
}